if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function() {

    $(document).ready(function() {
        $('.btn').prepend('<svg class="svg-circle" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle class="circle-1" cx="32" cy="32" r="30"></circle><circle class="circle-2" cx="32" cy="32" r="30"></circle></svg>');
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $("#privary-navigation li").children("a.active").parent().addClass('active');

    $("#privary-navigation li").children("a").hover(
        function() {
            if (!$(this).hasClass('active')) {
                $(this).parent().addClass('active');
            }
        },
        function() {
            if (!$(this).hasClass('active')) {
                $(this).parent().removeClass('active');
            }
        }
    );

    /* Press Form */
    let pressbtn = document.getElementById('press_form_toggle');
    if (pressbtn) {
        let theform = document.getElementById('press_form');
        pressbtn.addEventListener('click', (e) => {
            e.preventDefault();
            pressbtn.classList.toggle('active');
            theform.classList.toggle('active');
        })
    }

    // Make form's checkbox mandatory
    let subscribeCheckbox = document.querySelector('.custom-form [name="subscribe"]');
    if (subscribeCheckbox) {
        subscribeCheckbox.classList.add("required");
    }

    $('.sym-slides').slick({
        accessibility: false,
        autoplay: false
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Prev"><span class="text">Prev</span></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><span class="text">Next</span></button>',
        accessibility: false,
        responsive: [{
            breakpoint: 600,
            settings: {
                autoplay: true,
                autoplaySpeed: 2000,
            }
        }]
    });

    $('.slider-info-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Prev"><span class="text">Prev</span></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><span class="text">Next</span></button>',
        accessibility: true,
        responsive: [{
            breakpoint: 600,
            settings: {
                autoplay: false
            }
        }]
    });

    $('.slider-gallery').slick({
        arrows: true,
        dots: false,
        infinite: true,
        initialSlide: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        accessibility: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Prev"><span class="text">Prev</span></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next"><span class="text">Next</span></button>',
        centerMode: true,
        variableWidth: true,
    });

    $('.specials-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: true,
        // variableWidth: true,
        responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: "unslick"
            }
        ]
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if (ScrollDown.length > 0) {
        ScrollDown[0].addEventListener('click', function() {
            animateto('intro');
        });
    }





    if (document.getElementById('terms_btn')) {
        let btnTerms = document.getElementById('terms_btn');
        let termsInfo = document.getElementById('terms_info');
        let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
        btnTerms.addEventListener('click', function(e) {
            e.preventDefault();
            termsInfo.classList.toggle('open');
            if (!this.classList.contains('active')) {
                this.classList.add('active');
                termsInfo.style.height = termsInfoHeight + 'px';
            } else {
                this.classList.remove('active');
                termsInfo.style.height = '0px';
            }
        });
    }
    if (document.getElementsByClassName('terms-copy').length > 0) {
        let allTermsFancy = document.getElementsByClassName('js-terms');
        let allTermsLength = allTermsFancy.length;
        for (let j = 0; j < allTermsLength; j++) {
            allTermsFancy[j].addEventListener('click', function(e) {
                e.preventDefault();
                let target = this.getAttribute('href').split('#')[1];
                let wrapHeight = document.getElementById(target).getElementsByClassName('wrap')[0].clientHeight;
                if (!document.getElementById(target).classList.contains('open')) {
                    this.classList.add('active');
                    document.getElementById(target).classList.add('open')
                    document.getElementById(target).style.height = wrapHeight + 'px';
                } else {
                    this.classList.remove('active');
                    document.getElementById(target).classList.remove('open');
                    document.getElementById(target).style.height = '0px'
                }
            })
        }
    }

    if (document.querySelector('.footer-black')) {
        var submitSignUp = document.getElementById("email-signup").getElementsByClassName("signup-btn ")[0];
        submitSignUp.setAttribute('aria-label', 'Subscribe to our email database');
    }
    if (document.getElementById('form_id-666')) {
        var submitSignUp = document.getElementById("form_id-666").getElementsByClassName("btn")[0];
        submitSignUp.setAttribute('aria-label', 'submit form to contact our inn');
    }

    /*let ScrollBooking = document.getElementsByClassName('open-booking');
    if(ScrollBooking.length > 0){
        ScrollBooking[0].addEventListener('click', function(){
            animateto('email-signup');
        });
    }*/
    let hashValue = window.location.hash; 
    let menuItem = document.getElementById("afternoon-tea");

    if(hashValue == "#afternoon-tea" && menuItem){
        setTimeout(()=>{
            menuItem.click();
        }, 500)
    }
   


    
})();

function animateto(target) {
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from = window.pageYOffset
    var to = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if (from <= to) {
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}